import $ from 'jquery';

$(function(){
  $('.p-faq-accordion dt').click(function(){
    $(this).next().slideToggle();
    $(this).toggleClass('is-open');
  });
});